import type { CorridorStat } from "../data/types";

const COUNTRY_NAMES: Record<string, string> = {
  NG: "Nigeria",
  KE: "Kenya",
  UG: "Uganda",
  GH: "Ghana",
  CM: "Cameroon",
  RW: "Rwanda",
  TZ: "Tanzania",
  ZA: "South Africa",
  CI: "Côte d'Ivoire",
  SN: "Senegal",
  US: "United States",
  GB: "UK",
  FR: "France",
  DE: "Germany",
  NL: "Netherlands",
  AE: "UAE",
  IN: "India",
  CN: "China",
  SG: "Singapore",
  BF: "Burkina Faso",
  ET: "Ethiopia",
  EG: "Egypt",
};

function countryName(code: string): string {
  return COUNTRY_NAMES[code.toUpperCase()] ?? code;
}

export function TopCorridors({ corridors }: { corridors: CorridorStat[] }) {
  return (
    <div className="top-corridors">
      <div className="corridors-label">SEND CORRIDORS · TODAY</div>
      <ul>
        {corridors.map((c) => (
          <li key={c.key}>
            <span className="pair">
              {countryName(c.countryA)} <span className="arrow">→</span> {countryName(c.countryB)}
            </span>
            <span className="vol">${formatAmount(c.volumeUsd60m)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function formatAmount(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 1000) return (n / 1000).toFixed(1) + "K";
  return Math.round(n).toLocaleString("en-US");
}
